import axios from "axios";

export const getProductStats = async (id) => {
    try {
      const brear = localStorage.getItem("token");
      const lang = localStorage.getItem("i18nextLng")
      const { data } = await axios.get(
        `/v1/admin/products/${id}/stats`,   
        {
      
          
          headers: {Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang:lang}}
      );
      return data;
    } catch (error) {
    throw error
    }
  };